import { render, staticRenderFns } from "./RowElement.vue?vue&type=template&id=4b35265a&scoped=true&"
import script from "./RowElement.vue?vue&type=script&lang=js&"
export * from "./RowElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35265a",
  null
  
)

export default component.exports